/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SoftDatePicker from "components/SoftDatePicker";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: 1,
      bg: false,
    },
    subcontractorsName: {
      value: "",
      bg: false,
    },
    subcontractorsId : {
      value: "",
      bg: false,
    },
    foreignContractorName: {
      value: "",
      bg: false,
    },
    taxId: {
      value: "",
      bg: false,
    },
    category: {
      value: "",
      bg: false,
    },
    address: {
      value: "",
      bg: false,
    },
    startDate: {
      value: "",
      bg: false,
    },
    endDate: {
      value:"",
      bg: false,
    },
    valueOfContract: {
      value: 0,
      bg: false,
    },
    revenue: {
      value: 0,
      bg: false,
    },
  },
];

export default function Table2({setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const options = [
    { value: "options 1"},
    { value: "options 2"},
    { value: "options 3"},
  ];

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;

    const newRow =   {
      bold: false,
      id: {
        value: newIdValue,
        bg: false,
      },
      subcontractorsName: {
        value: "",
        bg: false,
      },
      subcontractorsId : {
        value: "",
        bg: false,
      },
      foreignContractorName: {
        value: "",
        bg: false,
      },
      taxId: {
        value: "",
        bg: false,
      },
      category: {
        value: "",
        bg: false,
      },
      address: {
        value: "",
        bg: false,
      },
      startDate: {
        value: "",
        bg: false,
      },
      endDate: {
        value:"",
        bg: false,
      },
      valueOfContract: {
        value: 0,
        bg: false,
      },
      revenue: {
        value: 0,
        bg: false,
      },
    }
    setData((prev) => [...prev, newRow]);
  };
  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
          <table style={tableStyle}>
            <thead style={{ background: "#eaeae9" }}>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  STT
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Tên nhà thầu phụ
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Mã số thuế của nhà thầu phụ tại Việt Nam (nếu có)
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                  Nhà thầu nước ngoài ký hợp đồng
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                 Loại hàng hoá, dịch vụ
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Địa điểm thưc hiện
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                  Thời hạn hợp đồng
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Giá trị của hợp đồng
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Doanh thu chưa bao gồm thuế giá trị gia tăng
                </Th>
              </tr>
              <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                  Tên nhà thầu nước ngoài
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                  Mã số thuế của nhà thầu nước ngoài tại Việt Nam (nếu có)
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Từ ngày</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Đến ngày</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(1)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>(3)</Th>
                <Th style={{ textAlign: "center" }}>(4)</Th>
                <Th style={{ textAlign: "center" }}>(5)</Th>
                <Th style={{ textAlign: "center" }}>(6)</Th>
                <Th style={{ textAlign: "center" }} colSpan="2">(7)</Th>
                <Th style={{ textAlign: "center" }}>(8)</Th>
                <Th style={{ textAlign: "center" }}>(9)</Th>
                <Th style={{ textAlign: "center" }}>(10)</Th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((row, index) => (
                  <tr key={row.id.value}>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.id.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                        {row.id.value}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.subcontractorsName.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.subcontractorsName.bg ? (
                        row.subcontractorsName.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="subcontractorsName"
                          value={row.subcontractorsName.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.subcontractorsId.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.subcontractorsId.bg ? (
                        row.subcontractorsId.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="subcontractorsId"
                          value={row.subcontractorsId.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.foreignContractorName.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.foreignContractorName.bg ? (
                        row.foreignContractorName.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="foreignContractorName"
                          value={row.foreignContractorName.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        background: !row.taxId.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxId.bg ? (
                        row.taxId.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="taxId"
                          value={row.taxId.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        background: !row.category.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.category.bg ? (
                        row.category.value
                      ) : (
                        <select
                          style={{
                            textAlign: "left",
                            fontSize: 14,
                            color: "#344767",
                            border: "none",
                            width: "200px",
                            background: "transparent",
                            padding: "4px 4px 4px 4px",
                          }}
                          onChange={(e) => handleChange({id: row.id.value, value: e.target.value, name: "category"})}
                        >
                          <option value="">--</option>
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.value}
                            </option>
                          ))}
                        </select>
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        background: !row.address.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.address.bg ? (
                        row.address.value
                      ) : (
                        <select
                          style={{
                            textAlign: "left",
                            fontSize: 14,
                            color: "#344767",
                            border: "none",
                            width: "200px",
                            background: "transparent",
                            padding: "4px 4px 4px 4px",
                          }}
                          onChange={(e) => handleChange({id: row.id.value, value: e.target.value, name: "address"})}
                        >
                          <option value="">--</option>
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.value}
                            </option>
                          ))}
                        </select>
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.startDate.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.startDate.bg ? (
                        row.startDate.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="startDate"
                          value={row.startDate.value}
                          onChange={handleChange}
                          type="date"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.endDate.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.endDate.bg ? (
                        row.endDate.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="endDate"
                          value={row.endDate.value}
                          onChange={handleChange}
                          type="date"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.valueOfContract.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.valueOfContract.bg ? (
                        row.valueOfContract.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="valueOfContract"
                          value={row.valueOfContract.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.revenue.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.revenue.bg ? (
                        row.revenue.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="revenue"
                          value={row.revenue.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                  </tr>
                ))}
              <tr>
                <Td colSpan="9"
                  row={{ bold: true }}
                  style={{
                    textAlign: "center",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng:
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >0</Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
              </tr>
            </tbody>
          </table>
        </Box>

        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
